import React, { useState } from 'react';
import Input from '../../../../../Components/Form/components/Input';
// @ts-ignore
import styles from './Password.module.scss';
import PasswordChecklist from 'react-password-checklist';
import usePasswordChecklist, {
	CheckListItem,
} from '../../../Hooks/usePasswordChecklist';

interface Props {
	placeholder?: string;
	name?: string;
	isRequired?: boolean;
	checklist?: CheckListItem[];
	loadChecklist?: boolean;
	netteRules: string;
}

const PasswordPHP: React.FC<Props> = props => {
	const { placeholder, name, isRequired, loadChecklist } = props;
	const [isHidden, setIsHidden] = useState(true);
	const [value, setValue] = useState<string>('');
	const { checklist, rules, messages, minLength, maxLength } =
		usePasswordChecklist({
			defaultChecklist: props.checklist,
			loadChecklist,
		});

	const handleSetValue = (event: React.ChangeEvent<HTMLInputElement>) => {
		// @ts-ignore
		const value = event.target.value;
		setValue(value);
	};

	return (
		<>
			<div className={styles.wrapper}>
				<Input
					type={isHidden ? 'password' : 'text'}
					placeholder={placeholder}
					name={name}
					required={isRequired}
					onChange={handleSetValue}
					data-nette-rules={props.netteRules}
				/>
				<div className={styles.iconWrapper}>
					<img
						src='/dist/patientV3/icons/eye-solid.svg'
						alt='eye'
						onClick={() => setIsHidden(prev => !prev)}
					/>
				</div>
			</div>
			{checklist && value && (
				<PasswordChecklist
					rules={rules}
					className='checklist'
					value={value}
					minLength={minLength}
					maxLength={maxLength}
					messages={messages}
				/>
			)}
		</>
	);
};

export default PasswordPHP;
